module.exports = __webpack_public_path__ + "static/media/white_img_a.afbec4a6.png";